import { FieldProps } from 'formik'
import { mapFieldToDatePicker } from 'formik-office-ui-fabric-react'
import { invokeAll } from 'helpers'
import * as React from 'react'
import { GenericDatePickerProps } from './GenericDatePicker'

export type FormikGenericDatePickerProps<TValue = any> = Omit<
  GenericDatePickerProps<TValue>,
  'value' | 'onBlur' | 'onChange' | 'onSelectDate'
> &
  Partial<Pick<GenericDatePickerProps<TValue>, 'onSelectDate'>> &
  FieldProps<TValue>

export const FormikGenericDatePickerFactory =
  <TValue extends any>(
    datePickerComponent: React.FunctionComponent<GenericDatePickerProps<TValue>>
  ): React.FunctionComponent<FormikGenericDatePickerProps<TValue>> =>
  ({ field, form, ...props }) => {
    const DatePickerComponent = datePickerComponent
    const { onAfterMenuDismiss, onSelectDate, ...fieldProps } =
      mapFieldToDatePicker({
        field,
        form,
      }) as any

    return (
      <DatePickerComponent
        {...props}
        onSelectDate={invokeAll(onSelectDate, props.onSelectDate)}
        onAfterMenuDismiss={invokeAll(
          onAfterMenuDismiss,
          props.onAfterMenuDismiss
        )}
        {...fieldProps}
      />
    )
  }
